import { Box } from "@mui/material";
import { ReactNode } from "react";

interface TabTableProps {
  children?: ReactNode;
  index: number;
  value: number;
}

const TabTable = ({ children, value, index, ...other }: TabTableProps) => {
  if (value !== index) return;
  return (
    <Box role="tabpanel" id={`tabTable-tabPanel-${index}`} {...other}>
      {children}
    </Box>
  );
};

export default TabTable;
